export const LOAD_RESERVATION_REVIEW_FOR_ADMIN = 'LOAD_RESERVATION_REVIEW_FOR_ADMIN';
export const UPDATE_SQUAD_QTY_FOR_ADMIN = 'UPDATE_SQUAD_QTY_FOR_ADMIN';
export const UPDATE_CART_TOTAL_FOR_ADMIN = 'UPDATE_CART_TOTAL_FOR_ADMIN';
export const UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN = 'UPDATE_VIRTUAL_EVENT_QTY_FOR_ADMIN';
export const PROCESSING_STARTED = 'PROCESSING_STARTED';
export const PROCESSING_FINISHED = 'PROCESSING_FINISHED';
export const DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN = 'DISPLAY_CLEAR_CART_CONFIRMATION_FOR_ADMIN';



// WEBPACK FOOTER //
// ./src/features/admin/review/constants.js